import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicLoaderComponent } from '../dynamic-loader/dynamic-loader.component';

@Component({
  selector: 'app-full-screen-loader',
  templateUrl: './full-screen-loader.component.html',
  styleUrls: ['./full-screen-loader.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DynamicLoaderComponent
  ]
})
export class FullScreenLoaderComponent {
  @Input() blurBackground = true;
  @Input() diameter = 40;
  @Input() stroke = 3;
  @Input() loaderType = 'company-loader';
}
